import { useQuery } from "@tanstack/react-query";
import { withNamespaces } from "react-i18next";
import { toast } from "react-toastify";
import { Progress } from "reactstrap";
import LicenseManagementService from "src/modules/3rd-party-management/apis/admin/LicenseManagementService";

const CreditUsage = ({ t }) => {
    const fetchCreditsQuery = useQuery({
        queryKey: [
            "3rd-party-management-fetch-compliance-total-credits-details"
        ],
        queryFn: async () => {
            const service = LicenseManagementService.getInstance();

            return await service.fetchComplianceTotalCredits();
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        retry: false,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t("An error occurred while fetching dashboard data."), {
                type: "error"
            });
        }
    });

    if (fetchCreditsQuery.isFetching) {
        return (
            <div>
                <div className="d-flex flex-column align-items-center">
                    <div className="d-flex align-items-center justify-content-between gap-2 w-100 mb-1">
                        <div className="dt-field dt-skeleton mb-2" style={{ width: '40%', height: '10px' }}></div>
                    </div>
                    <div className="w-100">
                        <div className="dt-field dt-skeleton mb-2" style={{ width: '100%', height: '40px' }}></div>
                    </div>
                </div>
            </div>
        );
    }

    const {
        screeningCredit
    } = fetchCreditsQuery.data || {};

    const allCredits = screeningCredit?.allCredits || 0;
    const usedCredits = screeningCredit?.usedCredits || 0;
    const currentAvailableCredits = screeningCredit?.currentAvailable || 0;

    const usedPercentage = allCredits > 0 ? (usedCredits / allCredits) * 100 : 0;

    return (
        <div>
            <div className="d-flex flex-column align-items-center">
                <div className="d-flex align-items-center justify-content-between gap-2 w-100 mb-1">
                    <small className="fw-bold">
                        {Math.round(usedPercentage)}%
                    </small>
                    <small className="text-muted">
                        {t("{{usedCredits}}/{{allCredits}} {{creditsLabel}} Used, {{currentAvailableCredits}} Available", {
                            usedCredits: usedCredits,
                            allCredits: allCredits,
                            creditsLabel: 'Credits',
                            currentAvailableCredits: currentAvailableCredits
                        })}
                    </small>
                </div>
                <div className="w-100">
                    <Progress
                        value={usedPercentage}
                    />
                </div>
            </div>
        </div>
    )
}

export default withNamespaces()(
    CreditUsage
);